import { Component, Input } from '@angular/core';
import { MandateCandidateListItem, CandidateListColumnDef } from './candidate-mandates.model';
import { ResultSummaryDto } from '@shared/clients/api.generated';

@Component({
  selector: 'valg-dk-candidate-mandates',
  templateUrl: './candidate-mandates.component.html',
  styleUrls: [ './candidate-mandates.component.scss' ]
})
export class CandidateMandatesComponent {
  @Input() data: MandateCandidateListItem[] = [];
  @Input() resultSummary?: ResultSummaryDto; 
  @Input() basedOnMissingResults = false;
  
  candidateListColumnDef = CandidateListColumnDef;
}
